import type { ICourse, IProduct } from '@/types/product'

import Section from '@/components/ui/atoms/Section'
import { CardCarousel } from '@/components/ui/molecules/card-carousel'

import ProductsListItem from '@/components/core/products/products.list.item'

import type { IPaymentStandard } from '@/types/payment'

export default function TeacherDetailsContent({
  courses,
  payment,
}: {
  courses: Array<ICourse>
  payment: IPaymentStandard
}) {
  const slideContent = (product: IProduct) => {
    return (
      <div className="pb-6 px-2">
        <ProductsListItem product={product} payment={payment} />
      </div>
    )
  }

  return (
    <Section id="teacher-content">
      <section>
        <h2 className="font-bold text-3xl mt-7">Cursos completos</h2>
        <CardCarousel elements={courses} id="_id" slideContent={slideContent} />
      </section>
    </Section>
  )
}
